import React, { useState , useEffect  } from "react";
import { Card, CardBody, Button, Input, Col, Container, Row , Spinner } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link } from 'react-router-dom';
import { useDispatch , useSelector } from "react-redux";
import {  group_list, reset_group_Owner } from "../../slices/thunks";
import Pagination from "../../Components/Common/Pagination_Cust";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import Create_New_Group_modal from "../../Components/Common/CustomModal/Create_New_Group_modal";
import CreateNewBot from "../../Components/Common/CustomModal/CreateNewBot";
import { set_bread_crum } from "../../slices/header/reducer";
import Prompt_Delete_modal from "../../Components/Prompt_Delete_modal";

const Groups = () => {
    const dispatch  = useDispatch()
    const navigate = useNavigate()
    const group_details = useSelector((state)=>state.Group_List)
    const [sort_by, setsort_by] = useState('')
    const [sort_order, setsort_order] = useState('DESC')


    const [filter, setfilter] = useState({
        
            page: 1,
            per_page: config.general_config.PER_PAGE_CONTENT,
            sort_by: null,
            sort_order: null,
            search_term: null,
            search_group_id: null,
            search_user_group_id: null,
            search_user_role: null
          
    })

  

    //fetches groups .
    useEffect(() => {
        
        dispatch(group_list(filter))
        
        
    }, [])

    const onPageChange = (page_number) => {
        let filter_temp = filter
        filter_temp.page=parseInt(page_number)
        setfilter(filter_temp)
        dispatch(group_list(filter_temp))
      }

      const onChangeSearch= (e)=>{
        let filter_temp = filter
        filter_temp.search_term=e.target.value
        setfilter(filter_temp)
        dispatch(group_list(filter_temp))
      } 


const onClick_Sort_Column = ({ column_name })=>{
    let filter_temp = filter;
    filter.sort_by= column_name;
    filter.sort_order=sort_order === 'DESC' ? 'ASC' : 'DESC'
    setsort_by(column_name)
    setsort_order(sort_order === 'DESC' ? 'ASC' : 'DESC')
    setfilter(filter_temp)
    dispatch(group_list(filter_temp))
}
    
    
useEffect(()=>{
    dispatch(set_bread_crum({ title:"Groups"  , pageTitle:"Dashboard"  }))

    dispatch(reset_group_Owner())

    return ()=>{
    dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
       
    }
  },[])



  return (
    <React.Fragment>
        <div className="page-content">
        {/* <div style={{ display:'none' }} ><CreateNewBot/></div> */}
        <Container fluid>
        {/* <BreadCrumb title="Groups" pageTitle="Dashboard" />         */}
            <Row>
                <Col lg={3}>
                <div className="m-mt-10 input-group">
                    <Input onChange={onChangeSearch} type="text" className="form-control h-40" aria-label="Search group name" placeholder="Search group name"/>
                    <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20"></i></button>
                </div>
                </Col>
                <Col lg={6}>  
                   
                </Col>
                <Col lg={3}>
                    <div className="m-mt-10 d-grid gap-2">
                        {/* <Button color="primary" className="rounded-pill"> CREATE NEW GROUP </Button> */}
                        <Create_New_Group_modal className="mb-3" />
                    </div>
                </Col>
            </Row>
            <Row className="mt-30">
                <Col>
                    <Card className="m-height"> 
                        <CardBody>
                            <div className="listjs-table" id="customerList_group">
                                <div className="table-responsive table-card mb-1">
                                    <table className="table align-middle table-nowrap" id="customerTable">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Action</th>
                                                <th onClick={()=>{
                                                    onClick_Sort_Column({ column_name:"Group_Name" })
                                                }}  className={`${ sort_by ==='Group_Name' && (sort_order==='ASC'? 'up':'down')}`} data-sort="group">Group</th>
                                                <th onClick={()=>{
                                                    onClick_Sort_Column({ column_name:"Group_ID" })
                                                }} className={`${ sort_by ==='Group_ID' && (sort_order==='ASC'? 'up': 'down')}`} data-sort="group_id">Group Id</th>
                                                <th onClick={()=>{
                                                    onClick_Sort_Column({ column_name:"User_Role" })
                                                }}  className={`${ sort_by ==='User_Role' && (sort_order==='ASC'? 'up': 'down')}`} data-sort="role">Role</th>
                                                <th  data-sort="token_balance"  style={{textAlign: 'right'}}>Token balance</th>
                                            </tr>
                                        </thead>
                                       {
                                        group_details.loading 
                                    // true
                                       ? <tbody><tr><td colSpan="5"><div className="loader_wrapper"><Spinner></Spinner></div></td></tr></tbody>: <tbody className="list">

                                            {
                                                group_details.groupList.map((ele,i)=>{
                                                    const {  Group_ID,
                                                        Group_Name,
                                                        User_Group_ID,
                                                        User_Role , Token_Balance } = ele;
                                                     return <tr key={i}>
                                                     <td className="edit_view">                                                    
                                                         {/* <span  ><i className="mdi mdi-eye-circle-outline"></i></span> */}
                                                         <span onClick={()=>{
                                                            navigate(`/Group_Dashboard?group_id=${Group_ID}`,{ state:{
                                                                Group_ID
                                                            }})
                                                         }} ><i className="mdi mdi-lead-pencil"></i></span>
                                                         {User_Role === 'Super User' && <Prompt_Delete_modal group_id={Group_ID} group_name={Group_Name} />}
                                                     </td>
                                                     <td 
                                                     
                                                     onClick={()=>{
                                                            navigate(`/Group_Dashboard?group_id=${Group_ID}`,{ state:{
                                                                Group_ID
                                                            }})
                                                         }} 
                                                         
                                                         className="group">{Group_Name}</td>
                                                     <td className="group_id">{Group_ID}</td>
                                                     <td className="role"><span className={`rounded-pill ${
                                                         User_Role === 'Super User' ? 'btn-outline-primary-cust' :
                                                         User_Role === 'General User' ? 'btn-outline-default-opa-cust' :
                                                         User_Role === 'Admin' ? 'btn-outline-secondary-cust-opa' :
                                                         'btn-outline-primary'
                                                        }`}> {User_Role} </span></td>
                                                        <td className="token_balance"  style={{textAlign: 'right'}}><span className="">{Token_Balance.toLocaleString()}</span></td>
                                                 </tr>    
                                                })
                                            }
                                                                                        
                                        </tbody>}
                                    </table>
                                    <div className="noresult" style={{ display: "none" }}>
                                        <div className="text-center">
                                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                                colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}>
                                            </lord-icon>
                                            <h5 className="mt-2">Sorry! No Result Found</h5>
                                            {/* <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any
                                                orders for you search.</p> */}
                                        </div>
                                    </div>
                                </div>

                                
                            </div>
                        </CardBody>
                    </Card>
                        <div className="d-flex justify-content-end">
                            <Pagination onPageChange={onPageChange} total_pages={group_details.totalPages} current_page={group_details.current_page} />
                        </div>
                </Col>
            </Row>
            
            
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Groups
